"use strict";

(function ($, Drupal, window, document) {
  // OnReady
  $(function () {
    var $epandBtn = $('.accordion-term .btn');

    if ($epandBtn.length) {
      $epandBtn.click(function () {
        var $this = $(this);
        var $target = $($this.attr('data-target'));
        $this.closest('.rm-block-expand').find('.view-more').toggleClass('active');
        $target.toggleClass('show');
      });
      $('.rm-block-expand .view-more').click(function () {
        $(this).closest('.rm-block-expand').find($epandBtn).trigger('click');
      });
    }
  });
})(jQuery, Drupal, window);